import { render } from "./ConfiguracaoDocumentosFiscaisEletronicosModal.vue?vue&type=template&id=23a45f36&scoped=true&ts=true"
import script from "./ConfiguracaoDocumentosFiscaisEletronicosModal.vue?vue&type=script&lang=ts"
export * from "./ConfiguracaoDocumentosFiscaisEletronicosModal.vue?vue&type=script&lang=ts"

import "./ConfiguracaoDocumentosFiscaisEletronicosModal.vue?vue&type=style&index=0&id=23a45f36&scoped=true&lang=css"

import exportComponent from "D:\\Desenvolvimento\\NeoXApp\\NeoX.Frontend\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-23a45f36"]])

export default __exports__